import React from 'react';
import {
  ArrowUpRightIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
  ArrowPathIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  StarIcon,
} from '@heroicons/react/24/outline';
import './cta-icon.css';

const icons = {
  open: ArrowUpRightIcon,
  next: ArrowRightIcon,
  back: ArrowLeftIcon,
  turn: ArrowPathIcon,
  up: ArrowUpIcon,
  down: ArrowDownIcon,
  star: StarIcon,
};

/** Bilt's existing outline icon geometry, independent of the platform emoji font. */
export default function CtaIcon({
  direction = 'open',
  compact = false,
  className = '',
}: {
  direction?: keyof typeof icons;
  compact?: boolean;
  className?: string;
}) {
  const Icon = icons[direction];
  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      strokeWidth={1.5}
      className={`bilt-cta-icon ${compact ? 'bilt-cta-icon--compact' : ''} ${className}`}
      data-direction={direction}
    />
  );
}
